import { useLocation } from '#router'
import { chromeFor, type RouteChrome } from '@/lib/routes'

/**
 * The chrome for the page currently rendering — the single answer for React
 * consumers, so no call site has to remember a second rule.
 *
 * `chromeFor` alone is not that answer: MDX course pages are served by the
 * `/courses/*?` route but come from the content registry, not the route
 * table, and their header never sticks. That rule lives here rather than in
 * `lib/routes.ts` because it needs the router's resolved page metadata, and
 * `lib/routes.ts` stays React-free for the build's sitemap script.
 */
export function useChrome(): RouteChrome {
  const location = useLocation()
  // A URL's pathname never carries the query string, but the header has
  // always stripped one defensively; keep doing it so a caller passing a
  // whole href still resolves to the right route.
  const chrome = chromeFor(location.pathname.split('?')[0])
  return location.course ? { ...chrome, sticky: false } : chrome
}
